<template>
  <div  ref="isChart" :deepCopyOnUpdate="false" id="isCharts"></div>
</template>
<script>
import Vue from 'vue'
import Highcharts from 'highcharts'
//  import HighchartsVue from 'highcharts-vue'
//    import stockInit from 'highcharts/modules/stock'
//    stockInit(Highcharts)
//  Vue.use(HighchartsVue)
export default {
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    xAxis: {
      type: Array,
      default: []
    },
    series: {
      type: Array,
      default: []
    }
  },
  watch: {
    'series' (newVal) {
      console.log(newVal)
      if (newVal) {
        Highcharts.chart('isCharts', {
          chart: {
            type: 'line'
          },

          //            color:['rgb(124, 181, 236)', 'rgb(67, 67, 72)', 'rgb(144, 237, 125)', 'rgb(247, 163, 92)', 'rgb(128, 133, 233)'],
          title: {
            text: this.title //月平均气温
          },
          subtitle: {
            text: this.subtitle //数据来源:
          },
          credits: {enabled: false},
          xAxis: {
            categories: this.xAxis
          },
          yAxis: {
            title: {
              enabled: false
            }
          },
          plotOptions: {
            line: {
              dataLabels: {
                enabled: true,
                color: '',
                formatter: function (data, i) {
                  return this.series.userOptions.dataText[this.point.index]
                }
              },
              enableMouseTracking: true
            }
          },
          tooltip: {
            //              headerFormat: '<b>{series.name}</b><br>',
            pointFormat: '{series.name}: {point.y:.2f} '
          },
          series: newVal
        })
        //         let chart= this.$refs['isChart']
        //          console.log(Highcharts)
        //           this.chartOptions.xAxis.categories =
        //           this.chartOptions.series =
        //           this.chartOptions.title.text = this.title
        //           this.chartOptions.subtitle.text = this.subtitle
        //          Highcharts.chart.setOption(this.chartOptions)
        //          newVal.forEach(obj=>{
        //            chart.addSeries(obj)
        //          })
      }
    }
  },
  data () {
    return {
      color: ['red', '#34348', '#90ED7D', '#F7A35C', '#8085E9'],
      hiCharts: null,
      upDateSeries: this.series
      //        chartOptions: {
      //          chart: {
      //            type: 'line'
      //          },
      //          title: {
      //            text: this.title //月平均气温
      //          },
      //          subtitle: {
      //            text: this.subtitle //数据来源:
      //          },
      //          credits: {enabled: false},
      //          xAxis: {
      //            categories: this.xAxis
      //          },
      //          yAxis: {
      //            title: {
      //              enabled: false
      //            }
      //          },
      //          plotOptions: {
      //            line: {
      //              dataLabels: {
      //                enabled: true,
      //                formatter: function (data, i) {
      //                  return this.series.userOptions.dataText[this.point.index]
      //                }
      //              },
      //              enableMouseTracking: true
      //            }
      //          },
      //          tooltip: {
      //            headerFormat: '<b>{series.name}</b><br>',
      //            pointFormat: '{series.name}: {point.y:.2f} '
      //          },
      //          series: [
      //            {}
      //          ]
      //        }
    }
  }
}
</script>

<style ref="stylesheet/scss" lang="scss" scoped>
  /*div{*/
    /*color: rgb(128, 133, 233);*/
  /*}*/
  /**/
  /*color:['rgb(124, 181, 236)', 'rgb(67, 67, 72)', 'rgb(144, 237, 125)', 'rgb(247, 163, 92)', 'rgb(128, 133, 233)'],*/
</style>
